import React, { ReactElement } from 'react';
import { Label, Loader, Select } from 'idsk-react-components';
import PublikovanyTerminFilter from '../../../model/PublikovanyTerminFilter';
import { SafeParameterSetter } from '../../../model/SafeParameterSetter';
import useTezaurusList from '../../Admin/Tezaurus/List/hook/useTezaurusList';
import SearchInput from './SearchInput';
import './sidePanel.scss';
import PouzitiePredpisMultiSelect from './PouzitiePredpisMultiSelect';

interface Props {
  filter: PublikovanyTerminFilter;
  onUpdateField?: SafeParameterSetter<PublikovanyTerminFilter>;
  filterCopy: PublikovanyTerminFilter;
  onUpdateFieldCopy: SafeParameterSetter<PublikovanyTerminFilter>;
  setFilter: (filter: PublikovanyTerminFilter) => void;
}

const SidePanel = ({
  filter,
  onUpdateField,
  filterCopy,
  onUpdateFieldCopy,
  setFilter,
}: Props): ReactElement => {
  const {
    tezaurusList,
    tezaurusStatus,
  } = useTezaurusList();

  return (
    <div className="publikovany-termin-list-side-panel">
      <SearchInput
        filterCopy={filterCopy}
        label="Hľadaný termín"
        filterSearchText={filterCopy?.searchTextHladanyTermin}
        fieldName="searchTextHladanyTermin"
        onUpdateFieldCopy={onUpdateFieldCopy}
        setFilter={setFilter}
        className="slovlex-idsk-side-panel-input-wrapper termin-container"
        maxLength={764}
      />
      <div className="slovlex-idsk-side-panel-input-wrapper">
        <Label className="blue-label" htmlFor="tezaurus">Tezaurus</Label>
        <Loader loading={tezaurusStatus.loading}>
          <Select
            id="tezaurus"
            width="full"
            name="tezaurus"
            value={filter?.tezaurus?.uuid ? filter.tezaurus.uuid : ''}
            onChange={({ target }) => {
              const selectedTezaurus = tezaurusList.find(tezaurus => tezaurus.uuid === target.value);
              onUpdateField('tezaurus', target.value === '' ? null : selectedTezaurus);
            }}
          >
            <option key="Vyberte" value="">Vyberte</option>
            {(tezaurusList && tezaurusList?.length > 0) ? (
              <>
                {tezaurusList
                  ?.map(tezaurus => (
                    <option
                      key={tezaurus.uuid}
                      value={tezaurus.uuid}
                    >
                      {tezaurus.nazov}
                    </option>
                  ))}
              </>
            ) : (
              <option key="emptyOption" value="emptyOption" disabled>
                Nenašiel sa žiadny záznam.
              </option>
            )}
          </Select>
        </Loader>
      </div>
      <SearchInput
        filterCopy={filterCopy}
        label="Legálny zdroj"
        filterSearchText={filterCopy?.searchTextLegalnyZdroj}
        fieldName="searchTextLegalnyZdroj"
        onUpdateFieldCopy={onUpdateFieldCopy}
        setFilter={setFilter}
        className="slovlex-idsk-side-panel-input-wrapper"
        maxLength={254}
      />
      <SearchInput
        filterCopy={filterCopy}
        label="Doktrinálny zdroj"
        filterSearchText={filterCopy?.searchTextDoktrinalnyZdroj}
        fieldName="searchTextDoktrinalnyZdroj"
        onUpdateFieldCopy={onUpdateFieldCopy}
        setFilter={setFilter}
        className="slovlex-idsk-side-panel-input-wrapper"
        maxLength={254}
      />
      <PouzitiePredpisMultiSelect data={filter} onUpdateField={onUpdateField} />
    </div>
  );
};

export default SidePanel;
